export default __webpack_public_path__ + "static/media/alli-mini-aentli.292df574.png";